module.exports = __webpack_public_path__ + "img/npc.d9ea3c19.svg";